import React, { useState, useEffect } from 'react'
import { Wrapper, Description, RadioButton } from './Select.styles'
import { Spacing } from '@big-red-group/storefront-common-ui'

export type RadioButtonProps = {
  options: RadioButtonOption[]
  onChange: (value: string) => void
  name: string
  isDisabled?: boolean
  showDescription?: boolean
}

export type RadioButtonOption = {
  label: string
  value: string
  description?: string
  children?: React.ReactElement
  checked?: boolean
  disabled?: boolean
}

const RadioButtonGroup: React.FC<RadioButtonProps> = ({
  options,
  onChange,
  name,
  isDisabled,
  showDescription = false,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>('')

  useEffect(() => {
    const checkedOption = options.find((option) => option.checked)
    if (checkedOption) {
      setSelectedValue(checkedOption.value)
    }
  }, [options.map((option) => option.checked).join(',')])

  return (
    <Wrapper>
      {options.map(({ label, value, description, children, checked = false, disabled = false }) => (
        <RadioButton key={value}>
          <input
            checked={selectedValue === value}
            type="radio"
            disabled={disabled}
            data-testid={`select-${name}`}
            name={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSelectedValue(e.currentTarget.value)
              onChange(e.currentTarget.value)
            }}
            id={value}
            value={value}
          ></input>

          <label
            htmlFor={value}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? 'grey' : 'inherit' }}
          >
            {label}
            {(selectedValue === value || checked) && (
              <>
                {children && (
                  <span>
                    <Spacing size="S" />
                    {children}
                  </span>
                )}
              </>
            )}
            {showDescription && (
              <>
                <div>
                  <Spacing size="XXS" />
                  <Description>{description}</Description>
                </div>
                <Spacing size="S" />
              </>
            )}
          </label>
        </RadioButton>
      ))}
    </Wrapper>
  )
}

export default RadioButtonGroup
